import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "use", "position"];
import styled, { isTrellisTheme } from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { MERCURY_LAYER } from '../../constants';

// we have to omit position due to a naming conflict between the
// CSS property and the prop name
import { jsx as _jsx } from "react/jsx-runtime";
const backgroundColorMapping = {
  calypso: 'border-accent-blue-default',
  'candy-apple': 'border-accent-red-default',
  heffalump: 'fill-accent-neutral-default',
  koala: 'fill-tertiary-default',
  lorax: 'border-accent-orange-default',
  marigold: 'fill-caution-default',
  norman: 'border-accent-magenta-default',
  olaf: 'icon-core-subtle',
  oz: 'border-accent-green-default',
  pantera: 'fill-accent-neutral-default',
  sorbet: 'fill-accent-light-orange-default',
  thunderdome: 'border-accent-purple-default',
  beta: 'fill-accent-purple-default',
  free: 'fill-accent-orange-default',
  new: 'fill-accent-green-default'
};
export const getBackgroundColorToken = use => {
  var _backgroundColorMappi;
  return (_backgroundColorMappi = backgroundColorMapping[use]) !== null && _backgroundColorMappi !== void 0 ? _backgroundColorMappi : 'fill-accent-green-default';
};
const StyledSpan = styled.span.withConfig({
  displayName: "Ribbon__StyledSpan",
  componentId: "vizt2w-0"
})(({
  theme,
  $use = 'new',
  $position = 'right',
  $cssStyles
}) => {
  const tokenizedBackgroundColor = getBackgroundColorToken($use);
  const isTrellis = isTrellisTheme(theme);
  return Object.assign({
    position: 'absolute',
    top: '8px',
    zIndex: MERCURY_LAYER,
    boxShadow: theme.boxShadow['100'],
    padding: $position === 'right' ? `0 ${theme.space['200']} 0 ${theme.space['300']}` : `0 ${theme.space['300']} 0 ${theme.space['200']}`,
    borderRadius: $position === 'right' ? `${theme.borderRadius['400']} ${theme.borderRadius['100']} ${theme.borderRadius['100']} ${theme.borderRadius['400']}` : `${theme.borderRadius['100']} ${theme.borderRadius['400']} ${theme.borderRadius['400']} ${theme.borderRadius['100']}`
  }, $position === 'right' ? {
    right: '-4px'
  } : {
    left: '-4px'
  }, {
    // font styles
    color: $use === 'koala' ? theme.color['text-core-default'] : $use === 'marigold' ? theme.color['text-inverse-default'] : theme.color['text-core-on-fill-default'],
    textAlign: 'center',
    textTransform: isTrellis ? 'capitalize' : 'uppercase',
    verticalAlign: 'inherit',
    hyphens: 'manual'
  }, theme.typography['heading-25'], {
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    // colorStylesMixin
    backgroundColor: theme.color[tokenizedBackgroundColor],
    // badgeStylesMixin
    display: 'inline-block',
    lineHeight: '20px',
    minHeight: '20px'
  }, $cssStyles);
});
export const Ribbon = _ref => {
  let {
      children,
      use = 'new',
      position = 'right'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    domProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledSpan, Object.assign({}, domProps, {
    "data-prevent-inherit-border-radius": "true",
    $use: use,
    $position: position,
    $cssStyles: cssStyles,
    children: children
  }));
};
Ribbon.displayName = 'Ribbon';